import { useEffect, useRef } from "react";

const TransferAutocomplete = ({ 
  placeholder, 
  onPlaceSelected, 
  defaultValue, 
  className = "form-control",
  id,
  name,
  style = {}
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && defaultValue) {
      inputRef.current.value = defaultValue;
    }
  }, [defaultValue]);

  useEffect(() => {
    if (inputRef.current && window.google && window.google.maps) {
      // Transfer için özel autocomplete ayarları
      autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
        fields: ["geometry", "name", "formatted_address", "types", "place_id"],
        strictBounds: false,
        types: ['establishment', 'geocode'], // Hem işletmeler hem de adresler
        componentRestrictions: {}, // Tüm ülkeler
      });

      autocompleteRef.current.addListener("place_changed", () => {
        const place = autocompleteRef.current.getPlace();
        
        if (place.geometry && place.geometry.location) {
          const placeData = {
            name: place.name || place.formatted_address,
            formatted_address: place.formatted_address,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            place_id: place.place_id,
            types: place.types || []
          };

          // Transfer türüne göre uygun yer tiplerini kontrol et
          const isAirport = place.types?.includes("airport");
          const isHotel = place.types?.includes("lodging") || place.types?.includes("hotel");
          const isTrainStation = place.types?.includes("train_station") || place.types?.includes("subway_station");
          const isBusStation = place.types?.includes("bus_station");
          const isEstablishment = place.types?.includes("establishment");
          
          // Yer türünü belirle
          let locationType = "address";
          if (isAirport) locationType = "airport";
          else if (isHotel) locationType = "hotel";
          else if (isTrainStation) locationType = "train_station";
          else if (isBusStation) locationType = "bus_station";
          else if (isEstablishment) locationType = "establishment";

          placeData.locationType = locationType;

          // Input değerini güncelle
          if (inputRef.current) {
            inputRef.current.value = place.name || place.formatted_address;
          }

          // Parent component'e bilgi gönder
          onPlaceSelected(placeData);
        }
      });
    }
  }, [onPlaceSelected]);

  return (
    <input 
      type="text" 
      ref={inputRef} 
      className={className}
      placeholder={placeholder}
      id={id}
      name={name}
      style={style}
      autoComplete="off"
    />
  );
};

export default TransferAutocomplete; 